//PAQUETERIAS
import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
//COMPONENTES

//IMAGENES/ICONOS

import { useDialog } from "react-st-modal";
import { catchErrorModul } from "../../../main_components/catchErr/catchError";
import { refresh_token } from "../../../main_components/tokens/tokenrefresh";
import { taxes_config_post } from "../../../services/invoices/taxes";


const ValidationTextField = styled(TextField)({
  "& input:valid + fieldset": { borderColor: "green", borderWidth: 2 },
  "& input:valid:focus + fieldset": {
    borderLeftWidth: 6,
    padding: "4px !important",
  },
});

const typeTR = [
  { value: "Traslado", label: "Traslado" },
  { value: "Retencion", label: "Retencion" },
];

const typeFactorTC = [
  { value: "Tasa", label: "Tasa" },
  { value: "Cuota", label: "Cuota" },
];

const Set_configure = ({ id_tax, setmodalT, alertas, setrec }) => {
  const [Rate, setRate] = React.useState("");
  const [Type, setType] = React.useState("Traslado");
  const [TypeFactor, setTypefactor] = React.useState("Tasa");
  const [open, setOpen] = useState(false);
  const [id_taxes, setId_taxes] = useState(id_tax);
  const dialog = useDialog();

  const handelRate = (event) => { setRate(event?.target?.value); };

  const handelType = (event) => { setType(event?.target?.value); };

  const handelTypeFactor = (event) => { setTypefactor(event?.target?.value); };

  useEffect(() => {
    handelRate();
  }, []);
  useEffect(() => {
    handelType();
  }, []);
  useEffect(() => {
    handelTypeFactor();
  }, []);

  const handleSubmit = async (event) => {
    event?.preventDefault();
    setOpen(true);

    var data = {
      rate: Number(Rate),
      type: (Type === undefined) ? "Traslado" : Type,
      c_tipofactor: (TypeFactor === undefined) ? "Tasa" : TypeFactor
    };
    try {
      setmodalT(true);
      var rf_token = await refresh_token();
      if (rf_token === true) {
        setTimeout(async () => {
          try {
            const d = await taxes_config_post(id_taxes, data);
            console.log(d);
            alertas('Éxito, configuración asignada correctamente', true);
            setmodalT(false);
            dialog.close();
            setrec(true);
          } catch (err) {
            catchErrorModul("Impuestos", JSON.stringify(data), JSON.stringify(err?.response === undefined ? "Token expirado" : err?.response));
            setmodalT(false);
            alertas("Error.," + err.response.data.errorMessage, false);
          }
        }, 1000);
      } else { }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <div>
        <form>
          <Box>
            <ValidationTextField
              label="Tarifa"
              variant="outlined"
              placeholder="Tarifa"
              sx={{ m: 2, width: "20ch" }}
              onChange={handelRate}
              value={Rate}
              InputLabelProps={{ shrink: true }}
            />

            <TextField
              select
              label="Tipo"
              value={Type}
              sx={{ m: 1.5, width: "20ch" }}
              onChange={handelType}
              size="small"
              name="taxes"
              InputLabelProps={{
                shrink: true,
              }}
              SelectProps={{
                native: true,
              }}
            >
              {typeTR.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                  selected={option.label}
                >
                  {option.label}
                </option>
              ))}
            </TextField>

            <TextField
              select
              label="Tipo factor"
              value={TypeFactor}
              sx={{ m: 1.5, width: "20ch" }}
              onChange={handelTypeFactor}
              size="small"
              name="taxes"
              InputLabelProps={{
                shrink: true,
              }}
              SelectProps={{
                native: true,
              }}
            >
              {typeFactorTC.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                  selected={option.label}
                >
                  {option.label}
                </option>
              ))}
            </TextField>
          </Box>

          <br></br>
          <br></br>

          <Box>
            <Button
              variant="contained"
              type="submit"
              className="ButtonModal"
              sx={{ m: 1.5, width: "30%" }}
              onClick={handleSubmit}
            >
              Agregar
            </Button>
            <Button
              variant="contained"
              className="ButtonModal2"
              sx={{ m: 1.5, width: "30%" }}
              onClick={() => {
                dialog.close();
              }}
            >
              cancelar
            </Button>
          </Box>
        </form>
      </div>
    </div>
  );
}

export default Set_configure;
